import type { Author } from '../../types';

export const authorSlug = (author: Pick<Author, 'id' | 'slug'>): string => author.slug || author.id;
